import { createContext, useMemo, useState } from "react";

type ContextType = {
  selected: number[];
  setSelected: React.Dispatch<React.SetStateAction<number[]>>;
};

export const ItemsSelectionContext = createContext<ContextType>({
  selected: [],
  setSelected: () => {},
});

interface Props {
  children: React.ReactNode;
}

function ItemsSelectionProvider({ children }: Props) {
  const [selected, setSelected] = useState<number[]>([]);

  const value = useMemo(
    () => ({
      selected,
      setSelected,
    }),
    [selected]
  );

  return (
    <ItemsSelectionContext.Provider value={value}>
      {children}
    </ItemsSelectionContext.Provider>
  );
}

export default ItemsSelectionProvider;
